module.exports = __webpack_public_path__ + "static/media/Transparency.b624c1d4.png";